<app-site-list />
<mat-accordion class="example-headers-align">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Mappa dei sites
      </mat-panel-title>
      <mat-panel-description>
        Clicca per espandere
        <i-tabler name="current-location"></i-tabler>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <app-cer-map />
  </mat-expansion-panel>
</mat-accordion>
<button mat-fab matTooltip="Aggiungi nuovo sito" routerLink="/administration/site/add" class="addButton bg-primary">
  <mat-icon>add</mat-icon>
</button>